import { Flex, Icon, SystemStyleObject, Text, Tooltip } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import IconContacts from '~/assets/svgs/icon-contacts.svg?react'
import { ExtensionBadgeVariant } from '~/components/shared/componentStyles/ExtensionBadge.style'
import { ExtensionBadge } from '~/components/shared/ExtensionBadge'
import { useContactCellStyles } from '~/pages/Calls/componentStyles/CallsListItem.style'
import { ContactDetails } from '~/pages/Contacts/viewModels/Contacts.viewmodel'
import { Size } from '~/types/ThemeTypes'

interface ContactCellProps {
  columnStyles: SystemStyleObject
  fromTitle: string
  toTitle: string
  fromSubtitle: string
  toSubtitle: string
  fromContact?: ContactDetails
  toContact?: ContactDetails
  fromNumber: string
  toNumber: string
  isFromExtension?: boolean
  isToExtension?: boolean
  transcriptionStatus?: string
}
export const ContactCombinedCell = ({
  columnStyles,
  fromTitle,
  toTitle,
  fromContact,
  toContact,
  fromNumber,
  toNumber,
  fromSubtitle,
  toSubtitle,
  isFromExtension,
  isToExtension,
}: ContactCellProps) => {
  const styles = useContactCellStyles()

  const fromTooltipLabel = useMemo(() => {
    return (
      <Flex paddingY="0.25rem" gap="0.5rem" alignItems="center">
        <Text sx={{ ...styles.subtitleText, color: 'white' }}>
          {fromSubtitle}
        </Text>
        {isFromExtension && (
          <ExtensionBadge
            extension={fromNumber}
            variant={ExtensionBadgeVariant.White}
            size={Size.sm}
          />
        )}
      </Flex>
    )
  }, [fromNumber, isFromExtension, fromSubtitle])

  const toTooltipLabel = useMemo(() => {
    return (
      <Flex paddingY="0.25rem" gap="0.5rem" alignItems="center">
        <Text sx={{ ...styles.subtitleText, color: 'white' }}>
          {toSubtitle}
        </Text>
        {isToExtension && (
          <ExtensionBadge
            extension={toNumber}
            variant={ExtensionBadgeVariant.White}
            size={Size.sm}
          />
        )}
      </Flex>
    )
  }, [toNumber, isToExtension, toSubtitle])

  return (
    <Flex sx={{ ...columnStyles, ...styles.container }}>
      <Flex sx={styles.titleContainer}>
        <Tooltip hasArrow placement="top-start" label={fromTooltipLabel}>
          <Flex gap="0.5rem" alignItems="center" maxWidth="100%">
            <Text sx={styles.titlePrefix}>F:</Text>
            {fromContact && <Icon as={IconContacts} sx={styles.titleIcon} />}

            <Text sx={styles.titleText}>{fromTitle}</Text>
          </Flex>
        </Tooltip>
      </Flex>
      <Flex sx={styles.titleContainer}>
        <Tooltip hasArrow placement="top-start" label={toTooltipLabel}>
          <Flex gap="0.5rem" alignItems="center" maxWidth="100%">
            <Text sx={styles.titlePrefix}>T:</Text>
            {toContact && <Icon as={IconContacts} sx={styles.titleIcon} />}
            <Text sx={styles.titleText}>{toTitle}</Text>
          </Flex>
        </Tooltip>
      </Flex>
    </Flex>
  )
}
